var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 296.48604808619484 575.25)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3993)",
    opacity: 1,
    d: "M-104.86 15.77L-116.76 15.77L-116.76 14.31Q-114.55 14.16-113.70 13.71Q-112.84 13.26-112.64 11.80L-112.64 11.80Q-112.29 9.49-112.29 5.58L-112.29 5.58L-112.29-14.30Q-112.29-16.41-112.89-16.86Q-113.50-17.31-116.81-17.51L-116.81-17.51L-116.81-18.97L-107.17-18.97Q-97.43-5.11-87.59 8.74L-87.59 8.74L-87.49 8.84L-87.49-8.78Q-87.49-12.69-87.84-15.00L-87.84-15.00Q-88.04-16.46-88.97-16.89Q-89.90-17.31-92.61-17.51L-92.61-17.51L-92.61-18.97L-80.72-18.97L-80.72-17.51Q-82.92-17.36-83.78-16.91Q-84.63-16.46-84.83-15.00L-84.83-15.00Q-85.18-12.69-85.18-8.78L-85.18-8.78L-85.18 15.77L-88.50 15.77Q-96.58 4.22-109.88-14.45L-109.88-14.45L-109.98-14.45L-109.98 5.58Q-109.98 9.49-109.63 11.80L-109.63 11.80Q-109.43 13.26-108.50 13.69Q-107.57 14.11-104.86 14.31L-104.86 14.31L-104.86 15.77Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3993",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3994)",
    opacity: 1,
    d: "M-78.41 3.67L-78.41 3.67Q-78.41-2.25-75.47-5.84Q-72.53-9.43-66.86-9.43L-66.86-9.43Q-64.25-9.43-62.29-8.65Q-60.33-7.87-59.31-6.77Q-58.28-5.67-57.65-4.16Q-57.02-2.65-56.87-1.55Q-56.72-0.44-56.72 0.66L-56.72 0.66Q-56.72 2.57-58.73 2.57L-58.73 2.57L-73.19 2.57Q-73.39 13.81-65.81 13.81L-65.81 13.81Q-63.10 13.81-61.41 12.41Q-59.73 11.00-58.53 8.49L-58.53 8.49L-57.02 9.29Q-59.43 16.37-66.81 16.37L-66.81 16.37Q-78.41 16.37-78.41 3.67ZM-73.14 0.66L-73.14 0.66L-63.65 0.66Q-62.64 0.66-62.29 0.26Q-61.94-0.14-61.94-0.95L-61.94-0.95Q-61.94-1.65-62.02-2.40Q-62.09-3.16-62.42-4.16Q-62.74-5.16-63.30-5.89Q-63.85-6.62-64.85-7.15Q-65.86-7.67-67.16-7.67L-67.16-7.67Q-68.97-7.67-70.27-6.69Q-71.58-5.72-72.13-4.23Q-72.68-2.75-72.91-1.55Q-73.14-0.34-73.14 0.66Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3994",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3995)",
    opacity: 1,
    d: "M-51.85-6.67L-53.76-6.92L-53.76-8.18L-45.88-9.43L-45.53-9.13L-45.53 7.94Q-45.53 10.75-44.14 12.21Q-42.76 13.66-40.46 13.66L-40.46 13.66Q-38.50 13.66-36.82 12.63Q-35.13 11.60-34.28 9.90L-34.28 9.90Q-33.88 9.09-33.88 6.88L-33.88 6.88L-33.88-4.41Q-33.88-5.72-34.18-6.12Q-34.48-6.52-35.49-6.67L-35.49-6.67L-37.39-6.92L-37.39-8.18L-29.51-9.43L-29.16-9.13L-29.16 11.40Q-29.16 13.31-28.61 13.71Q-28.06 14.11-25.40 14.31L-25.40 14.31L-25.40 15.77L-33.43 15.77L-33.93 12.76Q-33.98 12.81-35.79 13.91Q-37.59 15.02-39.40 15.69Q-41.21 16.37-43.12 16.37L-43.12 16.37Q-46.28 16.37-48.26 14.62Q-50.24 12.86-50.24 8.84L-50.24 8.84L-50.24-4.41Q-50.24-5.72-50.55-6.12Q-50.85-6.52-51.85-6.67L-51.85-6.67Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3995",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3996)",
    opacity: 1,
    d: "M-9.78 15.77L-23.04 15.77L-23.04 14.31Q-20.38 14.11-19.82 13.71Q-19.27 13.31-19.27 11.40L-19.27 11.40L-19.27-4.41Q-19.27-5.72-19.57-6.12Q-19.87-6.52-20.88-6.67L-20.88-6.67L-22.78-6.92L-22.78-8.18L-15.15-9.43L-14.55-5.41Q-11.89-7.72-10.56-8.58Q-9.23-9.43-7.93-9.43L-7.93-9.43Q-6.57-9.43-5.92-8.68Q-5.26-7.92-5.26-6.97L-5.26-6.97Q-5.26-5.82-5.97-4.99Q-6.67-4.16-7.57-4.16L-7.57-4.16Q-8.13-4.16-8.58-4.41L-8.58-4.41Q-10.59-5.51-11.69-5.51L-11.69-5.51Q-12.74-5.51-13.65-4.23Q-14.55-2.95-14.55-0.34L-14.55-0.34L-14.55 11.40Q-14.55 13.31-13.85 13.71Q-13.15 14.11-9.78 14.31L-9.78 14.31L-9.78 15.77Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3996",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3997)",
    opacity: 1,
    d: "M-3.16 9.24L-3.16 9.24Q-3.16 4.68 1.51 3.27L1.51 3.27Q2.27 3.02 3.90 2.54Q5.53 2.07 6.46 1.76Q7.39 1.46 8.59 1.04Q9.80 0.61 10.52 0.21Q11.25-0.19 11.60-0.55L11.60-0.55L11.60-2.65Q11.60-5.36 10.35-6.52Q9.09-7.67 7.34-7.67L7.34-7.67Q3.62-7.67 2.16-2.75L2.16-2.75Q1.76-1.35 0.56-1.35L0.56-1.35Q-0.35-1.35-1.30-1.98Q-2.25-2.60-2.25-3.71L-2.25-3.71Q-2.25-5.87 0.76-7.65Q3.77-9.43 7.89-9.43L7.89-9.43Q10.60-9.43 12.36-8.83Q14.11-8.23 14.87-7.15Q15.62-6.07 15.87-5.09Q16.12-4.11 16.12-2.75L16.12-2.75L16.12 9.39Q16.12 13.31 17.88 13.71L17.88 13.71Q18.93 14.01 20.44 13.66L20.44 13.66L20.74 14.87Q17.73 16.37 14.82 16.37L14.82 16.37Q13.56 16.37 12.86 15.62Q12.15 14.87 11.55 13.36L11.55 13.36Q6.98 16.37 4.07 16.37L4.07 16.37Q0.71 16.37-1.22 14.31Q-3.16 12.26-3.16 9.24ZM1.91 8.54L1.91 8.54Q1.91 10.85 3.09 12.28Q4.27 13.71 6.53 13.71L6.53 13.71Q8.44 13.71 10.02 12.51Q11.60 11.30 11.60 8.59L11.60 8.59L11.60 1.51Q10.65 2.12 5.83 3.92L5.83 3.92Q3.72 4.73 2.82 5.75Q1.91 6.78 1.91 8.54Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3997",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3998)",
    opacity: 1,
    d: "M23.05-1.35L23.05-1.35Q23.05-9.43 27.62-14.55L27.62-14.55Q32.23-19.72 41.77-19.72L41.77-19.72Q48.20-19.72 52.41-17.76L52.41-17.76L52.41-9.93L50.91-9.93Q49.60-17.96 41.27-17.96L41.27-17.96Q37.91-17.96 35.40-16.58Q32.89-15.20 31.46-12.79Q30.03-10.38 29.35-7.57Q28.67-4.76 28.67-1.50L28.67-1.50Q28.67 0.56 28.97 2.57Q29.27 4.58 30.13 6.83Q30.98 9.09 32.31 10.80Q33.64 12.51 35.92 13.64Q38.21 14.77 41.17 14.77L41.17 14.77Q45.79 14.77 48.17 12.43Q50.56 10.10 51.71 5.73L51.71 5.73L53.22 5.73L52.52 14.11Q50.66 15.12 47.52 15.82Q44.38 16.52 41.47 16.52L41.47 16.52Q32.08 16.52 27.82 12.26L27.82 12.26Q23.05 7.49 23.05-1.35Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3998",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_3999)",
    opacity: 1,
    d: "M53.52-7.37L53.52-7.37L53.52-8.83L65.02-8.83L65.02-7.37L62.86-7.17Q62.05-7.12 61.93-6.69Q61.80-6.27 62.10-5.62L62.10-5.62Q64.86 2.27 68.28 11.20L68.28 11.20L68.38 11.20Q72.85-0.95 73.95-5.41L73.95-5.41Q74.35-6.97 73.25-7.12L73.25-7.12L70.64-7.37L70.64-8.83L80.28-8.83L80.28-7.37Q78.47-7.27 77.87-6.82Q77.26-6.37 76.56-4.81L76.56-4.81Q73.35 2.42 67.27 19.89L67.27 19.89Q66.37 22.55 65.39 24.25Q64.41 25.96 63.46 26.71Q62.51 27.47 61.78 27.69Q61.05 27.92 60.15 27.92L60.15 27.92Q58.64 27.92 57.64 27.09Q56.63 26.26 56.63 25.31L56.63 25.31Q56.63 24.25 57.36 23.38Q58.09 22.50 58.84 22.50L58.84 22.50Q59.54 22.50 60.35 23.20L60.35 23.20Q61.40 24.25 62.20 24.25L62.20 24.25Q63.46 24.25 64.41 22.15L64.41 22.15Q65.62 19.59 65.62 17.88L65.62 17.88Q65.62 16.57 65.22 15.42L65.22 15.42Q62.56 7.74 57.33-4.76L57.33-4.76Q56.68-6.42 56.00-6.85Q55.33-7.27 53.52-7.37Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_3999",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4000)",
    opacity: 1,
    d: "M82.08-18.77L80.18-18.97L80.18-20.22L88.06-21.48L88.41-21.18L88.41-5.87Q88.56-5.97 89.94-6.85Q91.32-7.72 92.07-8.13Q92.83-8.53 94.26-8.98Q95.69-9.43 97.04-9.43L97.04-9.43Q99.60-9.43 101.51-8.40Q103.42-7.37 104.37-5.99Q105.33-4.61 105.90-2.73Q106.48-0.85 106.61 0.41Q106.73 1.66 106.73 2.92L106.73 2.92Q106.73 6.63 105.73 9.32Q104.72 12.00 102.94 13.51Q101.16 15.02 99.03 15.69Q96.89 16.37 94.23 16.37L94.23 16.37Q90.01 16.37 86.60 14.41L86.60 14.41L84.59 16.37L83.69 15.97L83.69-16.46Q83.69-17.86 83.39-18.27Q83.09-18.67 82.08-18.77L82.08-18.77ZM88.41-0.34L88.41 7.59Q88.41 9.70 88.76 10.75L88.76 10.75Q90.17 14.62 94.28 14.62L94.28 14.62Q101.51 14.62 101.51 3.22L101.51 3.22Q101.51 0.16 100.81-1.98Q100.10-4.11 99.00-5.06Q97.90-6.02 96.94-6.37Q95.99-6.72 95.03-6.72L95.03-6.72Q90.67-6.72 88.91-3.21L88.91-3.21Q88.41-2.20 88.41-0.34L88.41-0.34Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4000",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -118.51604808619444 -28.363)",
    x1: 0,
    y1: 0,
    x2: 237.0320961723889,
    y2: 56.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 312.48604808619484 528.608796478258)",
    style: {}
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4001)",
    opacity: 1,
    d: "M-71.56 3.82L-74.77 3.82L-74.77 3.46Q-73.96 3.42-73.82 3.31Q-73.67 3.20-73.67 2.69L-73.67 2.69L-73.67-3.46Q-73.67-3.97-73.82-4.08Q-73.96-4.19-74.77-4.24L-74.77-4.24L-74.77-4.59L-71.22-4.59Q-69.71-4.59-69.04-4.03Q-68.36-3.46-68.36-2.51L-68.36-2.51Q-68.36-1.67-68.91-1.11Q-69.46-0.55-70.34-0.37L-70.34-0.37L-70.34-0.35Q-69.46-0.13-69.14 0.38Q-68.82 0.90-68.69 1.86L-68.69 1.86Q-68.59 2.60-68.34 3.00Q-68.08 3.40-67.44 3.46L-67.44 3.46L-67.44 3.82L-68.42 3.82Q-69.54 3.82-69.78 2.77L-69.78 2.77Q-69.86 2.47-69.98 1.77Q-70.10 1.07-70.14 0.91L-70.14 0.91Q-70.40-0.14-71.63-0.14L-71.63-0.14L-72.47-0.14L-72.47 2.69Q-72.47 3.22-72.43 3.27L-72.43 3.27Q-72.42 3.31-72.39 3.32Q-72.36 3.34-72.31 3.36Q-72.26 3.38-72.22 3.39Q-72.18 3.40-72.09 3.42Q-71.99 3.43-71.94 3.43Q-71.89 3.44-71.76 3.45Q-71.63 3.45-71.56 3.46L-71.56 3.46L-71.56 3.82ZM-72.47-3.56L-72.47-0.57L-71.51-0.57Q-69.66-0.57-69.66-2.40L-69.66-2.40Q-69.66-3.38-70.21-3.77Q-70.77-4.17-71.58-4.17L-71.58-4.17Q-72.16-4.17-72.32-4.06Q-72.47-3.95-72.47-3.56L-72.47-3.56Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4001",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4002)",
    opacity: 1,
    d: "M-67.01 0.89L-67.01 0.89Q-67.01-0.55-66.30-1.41Q-65.59-2.28-64.22-2.28L-64.22-2.28Q-63.59-2.28-63.11-2.09Q-62.64-1.91-62.39-1.64Q-62.14-1.37-61.99-1.01Q-61.84-0.64-61.80-0.37Q-61.76-0.11-61.76 0.16L-61.76 0.16Q-61.76 0.62-62.25 0.62L-62.25 0.62L-65.75 0.62Q-65.80 3.34-63.96 3.34L-63.96 3.34Q-63.31 3.34-62.90 3.00Q-62.49 2.66-62.20 2.06L-62.20 2.06L-61.84 2.25Q-62.42 3.96-64.21 3.96L-64.21 3.96Q-67.01 3.96-67.01 0.89ZM-65.74 0.16L-65.74 0.16L-63.44 0.16Q-63.20 0.16-63.11 0.06Q-63.03-0.03-63.03-0.23L-63.03-0.23Q-63.03-0.40-63.05-0.58Q-63.06-0.76-63.14-1.01Q-63.22-1.25-63.36-1.43Q-63.49-1.60-63.73-1.73Q-63.98-1.86-64.29-1.86L-64.29-1.86Q-64.73-1.86-65.05-1.62Q-65.36-1.38-65.49-1.02Q-65.63-0.67-65.68-0.37Q-65.74-0.08-65.74 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4002",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4003)",
    opacity: 1,
    d: "M-60.67 3.38L-60.79 1.79L-60.44 1.79Q-60.03 3.54-58.67 3.54L-58.67 3.54Q-58.18 3.54-57.86 3.26Q-57.54 2.99-57.54 2.53L-57.54 2.53Q-57.54 2.24-57.65 2.01Q-57.77 1.79-57.99 1.64Q-58.22 1.50-58.40 1.42Q-58.58 1.34-58.85 1.25L-58.85 1.25Q-59.71 0.99-60.20 0.58Q-60.68 0.18-60.68-0.51L-60.68-0.51Q-60.68-1.36-60.08-1.82Q-59.48-2.28-58.47-2.28L-58.47-2.28Q-57.48-2.28-56.90-1.87L-56.90-1.87L-56.90-0.45L-57.26-0.45Q-57.33-1.06-57.67-1.46Q-58.01-1.86-58.62-1.86L-58.62-1.86Q-59.09-1.86-59.40-1.60Q-59.71-1.33-59.71-0.87L-59.71-0.87Q-59.71-0.56-59.46-0.31Q-59.21-0.07-58.99 0.01Q-58.78 0.10-58.41 0.22L-58.41 0.22Q-57.41 0.52-56.96 0.96Q-56.50 1.40-56.50 2.16L-56.50 2.16Q-56.50 2.95-57.11 3.46Q-57.72 3.96-58.78 3.96L-58.78 3.96Q-60.01 3.96-60.67 3.38L-60.67 3.38Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4003",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4004)",
    opacity: 1,
    d: "M-54.74-3.59Q-54.95-3.80-54.95-4.13Q-54.95-4.46-54.74-4.66Q-54.54-4.87-54.21-4.87Q-53.88-4.87-53.67-4.66Q-53.47-4.46-53.47-4.13Q-53.47-3.80-53.67-3.59Q-53.88-3.39-54.21-3.39Q-54.54-3.39-54.74-3.59ZM-52.71 3.82L-55.68 3.82L-55.68 3.46Q-55.02 3.42-54.89 3.32Q-54.77 3.22-54.77 2.76L-54.77 2.76L-54.77-1.07Q-54.77-1.38-54.84-1.48Q-54.91-1.58-55.15-1.61L-55.15-1.61L-55.62-1.67L-55.62-1.98L-53.71-2.28L-53.62-2.21L-53.62 2.76Q-53.62 3.22-53.50 3.32Q-53.37 3.42-52.71 3.46L-52.71 3.46L-52.71 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4004",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4005)",
    opacity: 1,
    d: "M-49.32 3.82L-52.29 3.82L-52.29 3.46Q-51.63 3.42-51.50 3.32Q-51.38 3.22-51.38 2.76L-51.38 2.76L-51.38-3.98Q-51.38-4.32-51.45-4.42Q-51.52-4.52-51.77-4.54L-51.77-4.54L-52.23-4.59L-52.23-4.89L-50.32-5.20L-50.23-5.13L-50.23 2.76Q-50.23 3.22-50.11 3.32Q-49.98 3.42-49.32 3.46L-49.32 3.46L-49.32 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4005",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4006)",
    opacity: 1,
    d: "M-47.82-3.59Q-48.02-3.80-48.02-4.13Q-48.02-4.46-47.82-4.66Q-47.61-4.87-47.28-4.87Q-46.95-4.87-46.75-4.66Q-46.54-4.46-46.54-4.13Q-46.54-3.80-46.75-3.59Q-46.95-3.39-47.28-3.39Q-47.61-3.39-47.82-3.59ZM-45.79 3.82L-48.75 3.82L-48.75 3.46Q-48.10 3.42-47.97 3.32Q-47.84 3.22-47.84 2.76L-47.84 2.76L-47.84-1.07Q-47.84-1.38-47.91-1.48Q-47.99-1.58-48.23-1.61L-48.23-1.61L-48.69-1.67L-48.69-1.98L-46.78-2.28L-46.70-2.21L-46.70 2.76Q-46.70 3.22-46.57 3.32Q-46.44 3.42-45.79 3.46L-45.79 3.46L-45.79 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4006",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4007)",
    opacity: 1,
    d: "M-45.01 0.89L-45.01 0.89Q-45.01-0.55-44.30-1.41Q-43.59-2.28-42.22-2.28L-42.22-2.28Q-41.58-2.28-41.11-2.09Q-40.64-1.91-40.39-1.64Q-40.14-1.37-39.99-1.01Q-39.83-0.64-39.80-0.37Q-39.76-0.11-39.76 0.16L-39.76 0.16Q-39.76 0.62-40.25 0.62L-40.25 0.62L-43.75 0.62Q-43.79 3.34-41.96 3.34L-41.96 3.34Q-41.30 3.34-40.90 3.00Q-40.49 2.66-40.20 2.06L-40.20 2.06L-39.83 2.25Q-40.42 3.96-42.20 3.96L-42.20 3.96Q-45.01 3.96-45.01 0.89ZM-43.73 0.16L-43.73 0.16L-41.44 0.16Q-41.19 0.16-41.11 0.06Q-41.02-0.03-41.02-0.23L-41.02-0.23Q-41.02-0.40-41.04-0.58Q-41.06-0.76-41.14-1.01Q-41.22-1.25-41.35-1.43Q-41.49-1.60-41.73-1.73Q-41.97-1.86-42.29-1.86L-42.29-1.86Q-42.73-1.86-43.04-1.62Q-43.36-1.38-43.49-1.02Q-43.62-0.67-43.68-0.37Q-43.73-0.08-43.73 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4007",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4008)",
    opacity: 1,
    d: "M-36.01 3.82L-38.97 3.82L-38.97 3.46Q-38.32 3.42-38.19 3.32Q-38.06 3.22-38.06 2.76L-38.06 2.76L-38.06-1.07Q-38.06-1.38-38.13-1.48Q-38.21-1.58-38.45-1.61L-38.45-1.61L-38.91-1.67L-38.91-1.98L-37.10-2.28L-36.93-1.36Q-36.88-1.40-36.63-1.56Q-36.37-1.72-36.31-1.76Q-36.25-1.80-36.04-1.92Q-35.82-2.04-35.72-2.08Q-35.62-2.11-35.43-2.18Q-35.24-2.25-35.07-2.26Q-34.90-2.28-34.72-2.28L-34.72-2.28Q-33.88-2.28-33.41-1.77Q-32.93-1.26-32.93-0.35L-32.93-0.35L-32.93 2.76Q-32.93 3.22-32.81 3.32Q-32.68 3.42-32.02 3.46L-32.02 3.46L-32.02 3.82L-34.99 3.82L-34.99 3.46Q-34.33 3.42-34.20 3.32Q-34.07 3.22-34.07 2.76L-34.07 2.76L-34.07-0.11Q-34.07-1.63-35.35-1.63L-35.35-1.63Q-35.81-1.63-36.20-1.38Q-36.59-1.13-36.80-0.75L-36.80-0.75Q-36.92-0.51-36.92-0.08L-36.92-0.08L-36.92 2.76Q-36.92 3.22-36.79 3.32Q-36.66 3.42-36.01 3.46L-36.01 3.46L-36.01 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4008",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4009)",
    opacity: 1,
    d: "M-30.59-1.65L-31.46-1.65L-31.46-2.14L-30.54-2.14L-29.80-3.67L-29.45-3.67L-29.45-2.14L-27.88-2.14L-27.88-1.65L-29.45-1.65L-29.45 2.12Q-29.45 3.33-28.64 3.33L-28.64 3.33Q-28.16 3.33-27.78 3.17L-27.78 3.17L-27.68 3.43Q-28.55 3.96-29.24 3.96L-29.24 3.96Q-29.45 3.96-29.64 3.91Q-29.83 3.87-30.07 3.74Q-30.30 3.61-30.44 3.31Q-30.59 3.01-30.59 2.58L-30.59 2.58L-30.59-1.65Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4009",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4010)",
    opacity: 1,
    d: "M-26.81 3.20L-26.81 3.20Q-26.81 2.86-26.60 2.63Q-26.38 2.41-26.04 2.41L-26.04 2.41Q-25.69 2.41-25.48 2.63Q-25.28 2.86-25.28 3.20L-25.28 3.20Q-25.29 3.54-25.49 3.75Q-25.69 3.96-26.04 3.96L-26.04 3.96Q-26.38 3.96-26.60 3.74Q-26.81 3.53-26.81 3.20Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4010",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4011)",
    opacity: 1,
    d: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4011",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4012)",
    opacity: 1,
    d: "M-17.70 3.82L-21.28 3.82L-21.28 3.46Q-20.48 3.42-20.33 3.31Q-20.19 3.20-20.19 2.69L-20.19 2.69L-20.19-3.46Q-20.19-3.97-20.33-4.08Q-20.48-4.19-21.28-4.24L-21.28-4.24L-21.28-4.59L-17.89-4.59Q-16.46-4.59-15.68-4.10L-15.68-4.10Q-14.73-3.51-14.73-2.21L-14.73-2.21Q-14.73-1.18-15.32-0.59Q-15.90-0.01-16.74 0.21L-16.74 0.21Q-17.38 0.37-18.29 0.37L-18.29 0.37L-18.98 0.37L-18.98 2.69Q-18.98 3.20-18.81 3.31Q-18.63 3.42-17.70 3.46L-17.70 3.46L-17.70 3.82ZM-18.98-3.72L-18.98-0.53Q-18.98-0.20-18.82-0.13Q-18.66-0.06-18.09-0.06L-18.09-0.06Q-17.21-0.06-16.63-0.56Q-16.04-1.07-16.04-2.12L-16.04-2.12Q-16.04-3.11-16.58-3.64Q-17.11-4.17-18.06-4.17L-18.06-4.17Q-18.63-4.17-18.81-4.07Q-18.98-3.98-18.98-3.72L-18.98-3.72Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4012",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4013)",
    opacity: 1,
    d: "M-14.19 0.89L-14.19 0.89Q-14.19-0.55-13.47-1.41Q-12.76-2.28-11.39-2.28L-11.39-2.28Q-10.76-2.28-10.28-2.09Q-9.81-1.91-9.56-1.64Q-9.31-1.37-9.16-1.01Q-9.01-0.64-8.97-0.37Q-8.94-0.11-8.94 0.16L-8.94 0.16Q-8.94 0.62-9.42 0.62L-9.42 0.62L-12.92 0.62Q-12.97 3.34-11.14 3.34L-11.14 3.34Q-10.48 3.34-10.07 3.00Q-9.67 2.66-9.37 2.06L-9.37 2.06L-9.01 2.25Q-9.59 3.96-11.38 3.96L-11.38 3.96Q-14.19 3.96-14.19 0.89ZM-12.91 0.16L-12.91 0.16L-10.61 0.16Q-10.37 0.16-10.28 0.06Q-10.20-0.03-10.20-0.23L-10.20-0.23Q-10.20-0.40-10.22-0.58Q-10.24-0.76-10.32-1.01Q-10.39-1.25-10.53-1.43Q-10.66-1.60-10.90-1.73Q-11.15-1.86-11.46-1.86L-11.46-1.86Q-11.90-1.86-12.22-1.62Q-12.53-1.38-12.67-1.02Q-12.80-0.67-12.85-0.37Q-12.91-0.08-12.91 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4013",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4014)",
    opacity: 1,
    d: "M-4.94 3.82L-8.15 3.82L-8.15 3.46Q-7.50 3.42-7.37 3.32Q-7.24 3.22-7.24 2.76L-7.24 2.76L-7.24-1.07Q-7.24-1.38-7.31-1.48Q-7.38-1.58-7.62-1.61L-7.62-1.61L-8.09-1.67L-8.09-1.98L-6.24-2.28L-6.09-1.31Q-5.45-1.87-5.13-2.08Q-4.81-2.28-4.49-2.28L-4.49-2.28Q-4.16-2.28-4.00-2.10Q-3.85-1.92-3.85-1.69L-3.85-1.69Q-3.85-1.41-4.02-1.21Q-4.19-1.01-4.40-1.01L-4.40-1.01Q-4.54-1.01-4.65-1.07L-4.65-1.07Q-5.13-1.33-5.40-1.33L-5.40-1.33Q-5.66-1.33-5.87-1.02Q-6.09-0.72-6.09-0.08L-6.09-0.08L-6.09 2.76Q-6.09 3.22-5.92 3.32Q-5.75 3.42-4.94 3.46L-4.94 3.46L-4.94 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4014",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4015)",
    opacity: 1,
    d: "M-3.12 3.38L-3.24 1.79L-2.89 1.79Q-2.47 3.54-1.11 3.54L-1.11 3.54Q-0.63 3.54-0.30 3.26Q0.02 2.99 0.02 2.53L0.02 2.53Q0.02 2.24-0.10 2.01Q-0.21 1.79-0.44 1.64Q-0.66 1.50-0.84 1.42Q-1.03 1.34-1.29 1.25L-1.29 1.25Q-2.16 0.99-2.64 0.58Q-3.13 0.18-3.13-0.51L-3.13-0.51Q-3.13-1.36-2.53-1.82Q-1.93-2.28-0.92-2.28L-0.92-2.28Q0.08-2.28 0.65-1.87L0.65-1.87L0.65-0.45L0.30-0.45Q0.22-1.06-0.12-1.46Q-0.46-1.86-1.06-1.86L-1.06-1.86Q-1.54-1.86-1.85-1.60Q-2.16-1.33-2.16-0.87L-2.16-0.87Q-2.16-0.56-1.91-0.31Q-1.66-0.07-1.44 0.01Q-1.22 0.10-0.86 0.22L-0.86 0.22Q0.14 0.52 0.60 0.96Q1.05 1.40 1.05 2.16L1.05 2.16Q1.05 2.95 0.44 3.46Q-0.16 3.96-1.22 3.96L-1.22 3.96Q-2.46 3.96-3.12 3.38L-3.12 3.38Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4015",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4016)",
    opacity: 1,
    d: "M2.81-3.59Q2.61-3.80 2.61-4.13Q2.61-4.46 2.81-4.66Q3.02-4.87 3.35-4.87Q3.68-4.87 3.88-4.66Q4.09-4.46 4.09-4.13Q4.09-3.80 3.88-3.59Q3.68-3.39 3.35-3.39Q3.02-3.39 2.81-3.59ZM4.84 3.82L1.88 3.82L1.88 3.46Q2.53 3.42 2.66 3.32Q2.79 3.22 2.79 2.76L2.79 2.76L2.79-1.07Q2.79-1.38 2.72-1.48Q2.64-1.58 2.40-1.61L2.40-1.61L1.94-1.67L1.94-1.98L3.85-2.28L3.93-2.21L3.93 2.76Q3.93 3.22 4.06 3.32Q4.19 3.42 4.84 3.46L4.84 3.46L4.84 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4016",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4017)",
    opacity: 1,
    d: "M5.72 3.38L5.60 1.79L5.95 1.79Q6.36 3.54 7.72 3.54L7.72 3.54Q8.21 3.54 8.53 3.26Q8.85 2.99 8.85 2.53L8.85 2.53Q8.85 2.24 8.74 2.01Q8.62 1.79 8.40 1.64Q8.17 1.50 7.99 1.42Q7.81 1.34 7.54 1.25L7.54 1.25Q6.68 0.99 6.19 0.58Q5.70 0.18 5.70-0.51L5.70-0.51Q5.70-1.36 6.31-1.82Q6.91-2.28 7.92-2.28L7.92-2.28Q8.91-2.28 9.48-1.87L9.48-1.87L9.48-0.45L9.13-0.45Q9.06-1.06 8.72-1.46Q8.38-1.86 7.77-1.86L7.77-1.86Q7.30-1.86 6.99-1.60Q6.68-1.33 6.68-0.87L6.68-0.87Q6.68-0.56 6.93-0.31Q7.17-0.07 7.39 0.01Q7.61 0.10 7.98 0.22L7.98 0.22Q8.97 0.52 9.43 0.96Q9.88 1.40 9.88 2.16L9.88 2.16Q9.88 2.95 9.28 3.46Q8.67 3.96 7.61 3.96L7.61 3.96Q6.37 3.96 5.72 3.38L5.72 3.38Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4017",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4018)",
    opacity: 1,
    d: "M11.57-1.65L10.70-1.65L10.70-2.14L11.62-2.14L12.36-3.67L12.71-3.67L12.71-2.14L14.28-2.14L14.28-1.65L12.71-1.65L12.71 2.12Q12.71 3.33 13.52 3.33L13.52 3.33Q14.00 3.33 14.38 3.17L14.38 3.17L14.48 3.43Q13.61 3.96 12.92 3.96L12.92 3.96Q12.71 3.96 12.52 3.91Q12.33 3.87 12.10 3.74Q11.86 3.61 11.72 3.31Q11.57 3.01 11.57 2.58L11.57 2.58L11.57-1.65Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4018",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4019)",
    opacity: 1,
    d: "M15.10 0.89L15.10 0.89Q15.10-0.55 15.81-1.41Q16.52-2.28 17.89-2.28L17.89-2.28Q18.52-2.28 19.00-2.09Q19.47-1.91 19.72-1.64Q19.97-1.37 20.12-1.01Q20.27-0.64 20.31-0.37Q20.35-0.11 20.35 0.16L20.35 0.16Q20.35 0.62 19.86 0.62L19.86 0.62L16.36 0.62Q16.31 3.34 18.15 3.34L18.15 3.34Q18.80 3.34 19.21 3.00Q19.62 2.66 19.91 2.06L19.91 2.06L20.27 2.25Q19.69 3.96 17.90 3.96L17.90 3.96Q15.10 3.96 15.10 0.89ZM16.37 0.16L16.37 0.16L18.67 0.16Q18.91 0.16 19.00 0.06Q19.08-0.03 19.08-0.23L19.08-0.23Q19.08-0.40 19.06-0.58Q19.05-0.76 18.97-1.01Q18.89-1.25 18.75-1.43Q18.62-1.60 18.38-1.73Q18.13-1.86 17.82-1.86L17.82-1.86Q17.38-1.86 17.06-1.62Q16.75-1.38 16.62-1.02Q16.48-0.67 16.43-0.37Q16.37-0.08 16.37 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4019",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4020)",
    opacity: 1,
    d: "M24.10 3.82L21.13 3.82L21.13 3.46Q21.79 3.42 21.92 3.32Q22.05 3.22 22.05 2.76L22.05 2.76L22.05-1.07Q22.05-1.38 21.97-1.48Q21.90-1.58 21.66-1.61L21.66-1.61L21.20-1.67L21.20-1.98L23.01-2.28L23.18-1.36Q23.22-1.40 23.48-1.56Q23.74-1.72 23.80-1.76Q23.86-1.80 24.07-1.92Q24.28-2.04 24.39-2.08Q24.49-2.11 24.68-2.18Q24.86-2.25 25.04-2.26Q25.21-2.28 25.39-2.28L25.39-2.28Q26.23-2.28 26.70-1.77Q27.17-1.26 27.17-0.35L27.17-0.35L27.17 2.76Q27.17 3.22 27.30 3.32Q27.43 3.42 28.08 3.46L28.08 3.46L28.08 3.82L25.12 3.82L25.12 3.46Q25.78 3.42 25.90 3.32Q26.03 3.22 26.03 2.76L26.03 2.76L26.03-0.11Q26.03-1.63 24.76-1.63L24.76-1.63Q24.29-1.63 23.91-1.38Q23.52-1.13 23.31-0.75L23.31-0.75Q23.19-0.51 23.19-0.08L23.19-0.08L23.19 2.76Q23.19 3.22 23.32 3.32Q23.44 3.42 24.10 3.46L24.10 3.46L24.10 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4020",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4021)",
    opacity: 1,
    d: "M29.52-1.65L28.64-1.65L28.64-2.14L29.57-2.14L30.31-3.67L30.66-3.67L30.66-2.14L32.23-2.14L32.23-1.65L30.66-1.65L30.66 2.12Q30.66 3.33 31.46 3.33L31.46 3.33Q31.95 3.33 32.33 3.17L32.33 3.17L32.42 3.43Q31.56 3.96 30.87 3.96L30.87 3.96Q30.66 3.96 30.47 3.91Q30.27 3.87 30.04 3.74Q29.81 3.61 29.66 3.31Q29.52 3.01 29.52 2.58L29.52 2.58L29.52-1.65Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4021",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4022)",
    opacity: 1,
    d: "M33.30 3.20L33.30 3.20Q33.30 2.86 33.51 2.63Q33.72 2.41 34.06 2.41L34.06 2.41Q34.41 2.41 34.62 2.63Q34.83 2.86 34.83 3.20L34.83 3.20Q34.82 3.54 34.62 3.75Q34.41 3.96 34.06 3.96L34.06 3.96Q33.72 3.96 33.51 3.74Q33.30 3.53 33.30 3.20Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4022",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4023)",
    opacity: 1,
    d: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4023",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4024)",
    opacity: 1,
    d: "M39.13 3.27L39.01 1.33L39.40 1.33Q39.63 2.37 40.19 2.97Q40.76 3.57 41.60 3.57L41.60 3.57Q42.41 3.57 42.88 3.12Q43.35 2.67 43.35 1.90L43.35 1.90Q43.35 1.40 43.01 0.98Q42.68 0.56 42.35 0.38Q42.02 0.20 41.66 0.05L41.66 0.05L41.44-0.03Q40.36-0.41 39.75-0.98Q39.14-1.54 39.14-2.43L39.14-2.43Q39.14-3.57 39.94-4.17Q40.75-4.77 41.94-4.77L41.94-4.77Q43.33-4.77 44.00-4.24L44.00-4.24L44.00-2.53L43.62-2.53Q43.33-4.35 41.80-4.35L41.80-4.35Q41.06-4.35 40.65-3.92Q40.25-3.50 40.25-2.80L40.25-2.80Q40.25-2.29 40.66-1.89Q41.07-1.49 41.74-1.25L41.74-1.25L42.13-1.10Q43.31-0.67 43.92-0.07Q44.52 0.52 44.52 1.53L44.52 1.53Q44.52 2.57 43.78 3.28Q43.03 4.00 41.52 4.00L41.52 4.00Q40.84 4.00 40.17 3.81Q39.51 3.62 39.13 3.27L39.13 3.27Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4024",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4025)",
    opacity: 1,
    d: "M45.42 0.89L45.42 0.89Q45.42-0.55 46.13-1.41Q46.84-2.28 48.22-2.28L48.22-2.28Q48.85-2.28 49.32-2.09Q49.80-1.91 50.05-1.64Q50.29-1.37 50.45-1.01Q50.60-0.64 50.64-0.37Q50.67-0.11 50.67 0.16L50.67 0.16Q50.67 0.62 50.19 0.62L50.19 0.62L46.69 0.62Q46.64 3.34 48.47 3.34L48.47 3.34Q49.13 3.34 49.54 3.00Q49.94 2.66 50.23 2.06L50.23 2.06L50.60 2.25Q50.02 3.96 48.23 3.96L48.23 3.96Q45.42 3.96 45.42 0.89ZM46.70 0.16L46.70 0.16L48.99 0.16Q49.24 0.16 49.32 0.06Q49.41-0.03 49.41-0.23L49.41-0.23Q49.41-0.40 49.39-0.58Q49.37-0.76 49.29-1.01Q49.21-1.25 49.08-1.43Q48.95-1.60 48.70-1.73Q48.46-1.86 48.14-1.86L48.14-1.86Q47.71-1.86 47.39-1.62Q47.08-1.38 46.94-1.02Q46.81-0.67 46.75-0.37Q46.70-0.08 46.70 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4025",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4026)",
    opacity: 1,
    d: "M51.67 0.90L51.67 0.90Q51.67 0.26 51.83-0.28Q51.98-0.82 52.31-1.29Q52.64-1.75 53.23-2.02Q53.82-2.28 54.62-2.28L54.62-2.28Q55.56-2.28 56.15-1.92Q56.73-1.55 56.73-1.10L56.73-1.10Q56.73-0.80 56.50-0.64Q56.26-0.48 56.02-0.48L56.02-0.48Q55.76-0.48 55.64-0.80L55.64-0.80Q55.25-1.86 54.49-1.86L54.49-1.86Q53.81-1.86 53.37-1.23Q52.93-0.61 52.93 0.68L52.93 0.68Q52.93 1.16 53.01 1.59Q53.09 2.02 53.28 2.43Q53.47 2.84 53.84 3.09Q54.21 3.33 54.72 3.33L54.72 3.33Q55.36 3.33 55.77 3.01Q56.18 2.70 56.47 2.04L56.47 2.04L56.82 2.21Q56.66 2.82 56.25 3.23Q55.84 3.65 55.39 3.80Q54.95 3.96 54.49 3.96L54.49 3.96Q53.11 3.96 52.39 3.19Q51.67 2.41 51.67 0.90Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4026",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4027)",
    opacity: 1,
    d: "M57.88-1.61L57.41-1.67L57.41-1.98L59.32-2.28L59.41-2.21L59.41 1.92Q59.41 2.60 59.74 2.95Q60.08 3.31 60.63 3.31L60.63 3.31Q61.11 3.31 61.52 3.06Q61.92 2.81 62.13 2.40L62.13 2.40Q62.23 2.20 62.23 1.67L62.23 1.67L62.23-1.07Q62.23-1.38 62.15-1.48Q62.08-1.58 61.84-1.61L61.84-1.61L61.38-1.67L61.38-1.98L63.28-2.28L63.37-2.21L63.37 2.76Q63.37 3.22 63.50 3.32Q63.64 3.42 64.28 3.46L64.28 3.46L64.28 3.82L62.34 3.82L62.21 3.09Q62.20 3.10 61.76 3.37Q61.33 3.63 60.89 3.80Q60.45 3.96 59.99 3.96L59.99 3.96Q59.23 3.96 58.75 3.54Q58.27 3.11 58.27 2.14L58.27 2.14L58.27-1.07Q58.27-1.38 58.19-1.48Q58.12-1.58 57.88-1.61L57.88-1.61Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4027",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4028)",
    opacity: 1,
    d: "M68.06 3.82L64.85 3.82L64.85 3.46Q65.49 3.42 65.63 3.32Q65.76 3.22 65.76 2.76L65.76 2.76L65.76-1.07Q65.76-1.38 65.69-1.48Q65.62-1.58 65.37-1.61L65.37-1.61L64.91-1.67L64.91-1.98L66.76-2.28L66.90-1.31Q67.55-1.87 67.87-2.08Q68.19-2.28 68.51-2.28L68.51-2.28Q68.84-2.28 68.99-2.10Q69.15-1.92 69.15-1.69L69.15-1.69Q69.15-1.41 68.98-1.21Q68.81-1.01 68.59-1.01L68.59-1.01Q68.46-1.01 68.35-1.07L68.35-1.07Q67.86-1.33 67.60-1.33L67.60-1.33Q67.34-1.33 67.12-1.02Q66.90-0.72 66.90-0.08L66.90-0.08L66.90 2.76Q66.90 3.22 67.07 3.32Q67.24 3.42 68.06 3.46L68.06 3.46L68.06 3.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4028",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4029)",
    opacity: 1,
    d: "M69.54 0.89L69.54 0.89Q69.54-0.55 70.25-1.41Q70.96-2.28 72.34-2.28L72.34-2.28Q72.97-2.28 73.44-2.09Q73.91-1.91 74.16-1.64Q74.41-1.37 74.56-1.01Q74.72-0.64 74.75-0.37Q74.79-0.11 74.79 0.16L74.79 0.16Q74.79 0.62 74.30 0.62L74.30 0.62L70.80 0.62Q70.76 3.34 72.59 3.34L72.59 3.34Q73.25 3.34 73.65 3.00Q74.06 2.66 74.35 2.06L74.35 2.06L74.72 2.25Q74.13 3.96 72.35 3.96L72.35 3.96Q69.54 3.96 69.54 0.89ZM70.82 0.16L70.82 0.16L73.11 0.16Q73.36 0.16 73.44 0.06Q73.53-0.03 73.53-0.23L73.53-0.23Q73.53-0.40 73.51-0.58Q73.49-0.76 73.41-1.01Q73.33-1.25 73.20-1.43Q73.06-1.60 72.82-1.73Q72.58-1.86 72.26-1.86L72.26-1.86Q71.82-1.86 71.51-1.62Q71.19-1.38 71.06-1.02Q70.93-0.67 70.87-0.37Q70.82-0.08 70.82 0.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4029",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -113.07855760979074 -6.864749999999999)",
    x1: 0,
    y1: 0,
    x2: 226.15711521958147,
    y2: 13.729499999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2d388a",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00aeef",
      stopOpacity: "undefined"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 285.33435715683635 518.25)",
    style: {}
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4030)",
    opacity: 1,
    d: "M-78.84 12.41L-88.20 12.41L-88.20 11.26Q-86.47 11.14-85.79 10.79Q-85.12 10.43-84.96 9.29L-84.96 9.29Q-84.69 7.47-84.69 4.39L-84.69 4.39L-84.69-11.25Q-84.69-12.91-85.16-13.27Q-85.64-13.62-88.24-13.78L-88.24-13.78L-88.24-14.93L-80.66-14.93Q-73.00-4.02-65.25 6.88L-65.25 6.88L-65.17 6.96L-65.17-6.91Q-65.17-9.99-65.45-11.80L-65.45-11.80Q-65.61-12.95-66.34-13.29Q-67.07-13.62-69.20-13.78L-69.20-13.78L-69.20-14.93L-59.84-14.93L-59.84-13.78Q-61.58-13.66-62.25-13.31Q-62.92-12.95-63.08-11.80L-63.08-11.80Q-63.36-9.99-63.36-6.91L-63.36-6.91L-63.36 12.41L-65.96 12.41Q-72.32 3.32-82.79-11.37L-82.79-11.37L-82.87-11.37L-82.87 4.39Q-82.87 7.47-82.59 9.29L-82.59 9.29Q-82.44 10.43-81.71 10.77Q-80.97 11.11-78.84 11.26L-78.84 11.26L-78.84 12.41Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4030",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4031)",
    opacity: 1,
    d: "M-58.03 2.89L-58.03 2.89Q-58.03-1.77-55.71-4.60Q-53.40-7.42-48.94-7.42L-48.94-7.42Q-46.89-7.42-45.35-6.81Q-43.81-6.20-43.00-5.33Q-42.19-4.46-41.69-3.27Q-41.20-2.09-41.08-1.22Q-40.96-0.35-40.96 0.52L-40.96 0.52Q-40.96 2.02-42.54 2.02L-42.54 2.02L-53.92 2.02Q-54.08 10.87-48.11 10.87L-48.11 10.87Q-45.98 10.87-44.65 9.76Q-43.33 8.66-42.38 6.68L-42.38 6.68L-41.20 7.31Q-43.09 12.88-48.90 12.88L-48.90 12.88Q-58.03 12.88-58.03 2.89ZM-53.88 0.52L-53.88 0.52L-46.41 0.52Q-45.62 0.52-45.35 0.20Q-45.07-0.11-45.07-0.74L-45.07-0.74Q-45.07-1.30-45.13-1.89Q-45.19-2.48-45.44-3.27Q-45.70-4.06-46.14-4.64Q-46.57-5.21-47.36-5.62Q-48.15-6.04-49.18-6.04L-49.18-6.04Q-50.60-6.04-51.63-5.27Q-52.65-4.50-53.09-3.33Q-53.52-2.17-53.70-1.22Q-53.88-0.27-53.88 0.52Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4031",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4032)",
    opacity: 1,
    d: "M-37.13-5.25L-38.63-5.45L-38.63-6.43L-32.43-7.42L-32.15-7.18L-32.15 6.25Q-32.15 8.46-31.07 9.60Q-29.98 10.75-28.16 10.75L-28.16 10.75Q-26.62 10.75-25.30 9.94Q-23.98 9.13-23.30 7.79L-23.30 7.79Q-22.99 7.16-22.99 5.42L-22.99 5.42L-22.99-3.47Q-22.99-4.50-23.23-4.81Q-23.46-5.13-24.25-5.25L-24.25-5.25L-25.75-5.45L-25.75-6.43L-19.55-7.42L-19.28-7.18L-19.28 8.97Q-19.28 10.47-18.84 10.79Q-18.41 11.11-16.31 11.26L-16.31 11.26L-16.31 12.41L-22.63 12.41L-23.03 10.04Q-23.07 10.08-24.49 10.95Q-25.91 11.82-27.33 12.35Q-28.76 12.88-30.26 12.88L-30.26 12.88Q-32.75 12.88-34.31 11.50Q-35.87 10.12-35.87 6.96L-35.87 6.96L-35.87-3.47Q-35.87-4.50-36.10-4.81Q-36.34-5.13-37.13-5.25L-37.13-5.25Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4032",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4033)",
    opacity: 1,
    d: "M-4.03 12.41L-14.46 12.41L-14.46 11.26Q-12.36 11.11-11.93 10.79Q-11.49 10.47-11.49 8.97L-11.49 8.97L-11.49-3.47Q-11.49-4.50-11.73-4.81Q-11.97-5.13-12.76-5.25L-12.76-5.25L-14.26-5.45L-14.26-6.43L-8.26-7.42L-7.78-4.26Q-5.69-6.08-4.64-6.75Q-3.59-7.42-2.57-7.42L-2.57-7.42Q-1.50-7.42-0.99-6.83Q-0.47-6.24-0.47-5.48L-0.47-5.48Q-0.47-4.58-1.03-3.92Q-1.58-3.27-2.29-3.27L-2.29-3.27Q-2.73-3.27-3.08-3.47L-3.08-3.47Q-4.66-4.34-5.53-4.34L-5.53-4.34Q-6.36-4.34-7.07-3.33Q-7.78-2.32-7.78-0.27L-7.78-0.27L-7.78 8.97Q-7.78 10.47-7.23 10.79Q-6.68 11.11-4.03 11.26L-4.03 11.26L-4.03 12.41Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4033",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4034)",
    opacity: 1,
    d: "M1.19 7.27L1.19 7.27Q1.19 3.68 4.86 2.57L4.86 2.57Q5.45 2.38 6.73 2.00Q8.02 1.63 8.75 1.39Q9.48 1.15 10.43 0.82Q11.38 0.48 11.95 0.16Q12.52-0.15 12.80-0.43L12.80-0.43L12.80-2.09Q12.80-4.22 11.81-5.13Q10.82-6.04 9.44-6.04L9.44-6.04Q6.52-6.04 5.37-2.17L5.37-2.17Q5.06-1.06 4.11-1.06L4.11-1.06Q3.40-1.06 2.65-1.55Q1.90-2.05 1.90-2.92L1.90-2.92Q1.90-4.62 4.27-6.02Q6.64-7.42 9.88-7.42L9.88-7.42Q12.01-7.42 13.39-6.95Q14.77-6.47 15.37-5.62Q15.96-4.77 16.16-4.00Q16.35-3.23 16.35-2.17L16.35-2.17L16.35 7.39Q16.35 10.47 17.74 10.79L17.74 10.79Q18.57 11.03 19.75 10.75L19.75 10.75L19.99 11.70Q17.62 12.88 15.33 12.88L15.33 12.88Q14.34 12.88 13.79 12.29Q13.23 11.70 12.76 10.51L12.76 10.51Q9.16 12.88 6.87 12.88L6.87 12.88Q4.23 12.88 2.71 11.26Q1.19 9.64 1.19 7.27ZM5.17 6.72L5.17 6.72Q5.17 8.54 6.10 9.66Q7.03 10.79 8.81 10.79L8.81 10.79Q10.31 10.79 11.55 9.84Q12.80 8.89 12.80 6.76L12.80 6.76L12.80 1.19Q12.05 1.66 8.26 3.09L8.26 3.09Q6.60 3.72 5.89 4.53Q5.17 5.34 5.17 6.72Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4034",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4035)",
    opacity: 1,
    d: "M21.80-1.06L21.80-1.06Q21.80-7.42 25.40-11.45L25.40-11.45Q29.03-15.52 36.54-15.52L36.54-15.52Q41.59-15.52 44.91-13.98L44.91-13.98L44.91-7.82L43.73-7.82Q42.70-14.14 36.14-14.14L36.14-14.14Q33.50-14.14 31.52-13.05Q29.55-11.96 28.42-10.07Q27.29-8.17 26.76-5.96Q26.23-3.75 26.23-1.18L26.23-1.18Q26.23 0.44 26.46 2.02Q26.70 3.60 27.37 5.38Q28.04 7.16 29.09 8.50Q30.14 9.84 31.94 10.73Q33.73 11.62 36.06 11.62L36.06 11.62Q39.70 11.62 41.57 9.78Q43.45 7.95 44.36 4.51L44.36 4.51L45.54 4.51L44.99 11.11Q43.53 11.90 41.06 12.45Q38.59 13.00 36.30 13.00L36.30 13.00Q28.91 13.00 25.56 9.64L25.56 9.64Q21.80 5.89 21.80-1.06Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4035",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4036)",
    opacity: 1,
    d: "M45.78-5.80L45.78-5.80L45.78-6.95L54.83-6.95L54.83-5.80L53.13-5.64Q52.50-5.60 52.40-5.27Q52.30-4.93 52.53-4.42L52.53-4.42Q54.71 1.78 57.39 8.81L57.39 8.81L57.47 8.81Q60.99-0.74 61.86-4.26L61.86-4.26Q62.17-5.48 61.30-5.60L61.30-5.60L59.25-5.80L59.25-6.95L66.83-6.95L66.83-5.80Q65.41-5.72 64.94-5.37Q64.46-5.01 63.91-3.79L63.91-3.79Q61.38 1.90 56.60 15.65L56.60 15.65Q55.89 17.74 55.12 19.08Q54.35 20.43 53.60 21.02Q52.85 21.61 52.28 21.79Q51.71 21.97 50.99 21.97L50.99 21.97Q49.81 21.97 49.02 21.32Q48.23 20.66 48.23 19.91L48.23 19.91Q48.23 19.08 48.80 18.39Q49.37 17.70 49.97 17.70L49.97 17.70Q50.52 17.70 51.15 18.25L51.15 18.25Q51.98 19.08 52.61 19.08L52.61 19.08Q53.60 19.08 54.35 17.43L54.35 17.43Q55.30 15.41 55.30 14.07L55.30 14.07Q55.30 13.04 54.98 12.13L54.98 12.13Q52.89 6.09 48.78-3.75L48.78-3.75Q48.27-5.05 47.74-5.39Q47.20-5.72 45.78-5.80Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4036",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4037)",
    opacity: 1,
    d: "M68.26-14.77L66.75-14.93L66.75-15.91L72.96-16.90L73.23-16.66L73.23-4.62Q73.35-4.69 74.44-5.39Q75.52-6.08 76.12-6.39Q76.71-6.71 77.83-7.06Q78.96-7.42 80.03-7.42L80.03-7.42Q82.04-7.42 83.54-6.61Q85.04-5.80 85.79-4.71Q86.54-3.63 87.00-2.15Q87.45-0.67 87.55 0.32Q87.65 1.31 87.65 2.30L87.65 2.30Q87.65 5.22 86.86 7.33Q86.07 9.45 84.67 10.63Q83.27 11.82 81.59 12.35Q79.91 12.88 77.81 12.88L77.81 12.88Q74.50 12.88 71.81 11.34L71.81 11.34L70.23 12.88L69.52 12.57L69.52-12.95Q69.52-14.06 69.28-14.37Q69.05-14.69 68.26-14.77L68.26-14.77ZM73.23-0.27L73.23 5.97Q73.23 7.63 73.51 8.46L73.51 8.46Q74.62 11.50 77.85 11.50L77.85 11.50Q83.54 11.50 83.54 2.53L83.54 2.53Q83.54 0.12 82.99-1.55Q82.44-3.23 81.57-3.98Q80.70-4.73 79.95-5.01Q79.20-5.29 78.45-5.29L78.45-5.29Q75.01-5.29 73.63-2.52L73.63-2.52Q73.23-1.73 73.23-0.27L73.23-0.27Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4037",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -89.66564284316367 -22.3175)",
    x1: 0,
    y1: 0,
    x2: 179.33128568632733,
    y2: 44.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 445.0731333195678 507.2828500650576)",
    style: {}
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4038)",
    opacity: 1,
    d: "M-79.96 4.18L-83.47 4.18L-83.47 3.79Q-82.59 3.74-82.43 3.62Q-82.27 3.50-82.27 2.94L-82.27 2.94L-82.27-3.79Q-82.27-4.35-82.43-4.47Q-82.59-4.59-83.47-4.64L-83.47-4.64L-83.47-5.03L-79.59-5.03Q-77.94-5.03-77.20-4.41Q-76.46-3.79-76.46-2.75L-76.46-2.75Q-76.46-1.83-77.06-1.22Q-77.66-0.60-78.63-0.41L-78.63-0.41L-78.63-0.38Q-77.66-0.14-77.31 0.42Q-76.97 0.99-76.82 2.04L-76.82 2.04Q-76.71 2.85-76.44 3.29Q-76.16 3.73-75.45 3.79L-75.45 3.79L-75.45 4.18L-76.53 4.18Q-77.75 4.18-78.02 3.03L-78.02 3.03Q-78.10 2.70-78.23 1.94Q-78.36 1.17-78.40 1.00L-78.40 1.00Q-78.70-0.16-80.04-0.16L-80.04-0.16L-80.96-0.16L-80.96 2.94Q-80.96 3.53-80.92 3.58L-80.92 3.58Q-80.90 3.62-80.87 3.64Q-80.84 3.66-80.78 3.68Q-80.73 3.70-80.68 3.71Q-80.64 3.73-80.54 3.74Q-80.44 3.75-80.38 3.76Q-80.32 3.77-80.18 3.77Q-80.04 3.78-79.96 3.79L-79.96 3.79L-79.96 4.18ZM-80.96-3.90L-80.96-0.62L-79.91-0.62Q-77.88-0.62-77.88-2.63L-77.88-2.63Q-77.88-3.70-78.49-4.13Q-79.10-4.56-79.99-4.56L-79.99-4.56Q-80.62-4.56-80.79-4.44Q-80.96-4.32-80.96-3.90L-80.96-3.90Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4038",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4039)",
    opacity: 1,
    d: "M-74.99 0.97L-74.99 0.97Q-74.99-0.60-74.21-1.55Q-73.43-2.50-71.93-2.50L-71.93-2.50Q-71.23-2.50-70.72-2.29Q-70.20-2.09-69.92-1.79Q-69.65-1.50-69.49-1.10Q-69.32-0.70-69.28-0.41Q-69.24-0.12-69.24 0.17L-69.24 0.17Q-69.24 0.68-69.77 0.68L-69.77 0.68L-73.60 0.68Q-73.66 3.66-71.65 3.66L-71.65 3.66Q-70.93 3.66-70.48 3.29Q-70.04 2.91-69.72 2.25L-69.72 2.25L-69.32 2.46Q-69.96 4.34-71.91 4.34L-71.91 4.34Q-74.99 4.34-74.99 0.97ZM-73.59 0.17L-73.59 0.17L-71.08 0.17Q-70.81 0.17-70.72 0.07Q-70.62-0.04-70.62-0.25L-70.62-0.25Q-70.62-0.44-70.64-0.64Q-70.66-0.84-70.75-1.10Q-70.84-1.37-70.98-1.56Q-71.13-1.75-71.39-1.89Q-71.66-2.03-72.01-2.03L-72.01-2.03Q-72.48-2.03-72.83-1.77Q-73.18-1.51-73.32-1.12Q-73.47-0.73-73.53-0.41Q-73.59-0.09-73.59 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4039",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4040)",
    opacity: 1,
    d: "M-68.04 3.70L-68.18 1.96L-67.79 1.96Q-67.34 3.87-65.85 3.87L-65.85 3.87Q-65.32 3.87-64.96 3.57Q-64.61 3.27-64.61 2.77L-64.61 2.77Q-64.61 2.45-64.74 2.20Q-64.86 1.96-65.11 1.80Q-65.36 1.64-65.56 1.55Q-65.76 1.46-66.05 1.37L-66.05 1.37Q-66.99 1.08-67.52 0.64Q-68.06 0.20-68.06-0.56L-68.06-0.56Q-68.06-1.49-67.40-1.99Q-66.74-2.50-65.64-2.50L-65.64-2.50Q-64.54-2.50-63.92-2.05L-63.92-2.05L-63.92-0.49L-64.31-0.49Q-64.39-1.16-64.76-1.59Q-65.13-2.03-65.80-2.03L-65.80-2.03Q-66.31-2.03-66.65-1.75Q-66.99-1.46-66.99-0.96L-66.99-0.96Q-66.99-0.61-66.72-0.34Q-66.45-0.08-66.21 0.02Q-65.97 0.11-65.57 0.24L-65.57 0.24Q-64.48 0.57-63.98 1.05Q-63.48 1.53-63.48 2.37L-63.48 2.37Q-63.48 3.23-64.15 3.79Q-64.81 4.34-65.97 4.34L-65.97 4.34Q-67.32 4.34-68.04 3.70L-68.04 3.70Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4040",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4041)",
    opacity: 1,
    d: "M-61.55-3.93Q-61.78-4.16-61.78-4.52Q-61.78-4.88-61.55-5.11Q-61.33-5.33-60.97-5.33Q-60.61-5.33-60.38-5.11Q-60.16-4.88-60.16-4.52Q-60.16-4.16-60.38-3.93Q-60.61-3.71-60.97-3.71Q-61.33-3.71-61.55-3.93ZM-59.33 4.18L-62.58 4.18L-62.58 3.79Q-61.86 3.74-61.72 3.63Q-61.58 3.53-61.58 3.02L-61.58 3.02L-61.58-1.17Q-61.58-1.51-61.66-1.62Q-61.74-1.73-62.00-1.77L-62.00-1.77L-62.51-1.83L-62.51-2.17L-60.42-2.50L-60.33-2.42L-60.33 3.02Q-60.33 3.53-60.19 3.63Q-60.05 3.74-59.33 3.79L-59.33 3.79L-59.33 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4041",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4042)",
    opacity: 1,
    d: "M-55.62 4.18L-58.87 4.18L-58.87 3.79Q-58.15 3.74-58.01 3.63Q-57.87 3.53-57.87 3.02L-57.87 3.02L-57.87-4.36Q-57.87-4.73-57.95-4.84Q-58.03-4.95-58.29-4.97L-58.29-4.97L-58.80-5.03L-58.80-5.36L-56.71-5.69L-56.62-5.61L-56.62 3.02Q-56.62 3.53-56.48 3.63Q-56.34 3.74-55.62 3.79L-55.62 3.79L-55.62 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4042",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4043)",
    opacity: 1,
    d: "M-53.97-3.93Q-54.20-4.16-54.20-4.52Q-54.20-4.88-53.97-5.11Q-53.75-5.33-53.39-5.33Q-53.03-5.33-52.80-5.11Q-52.57-4.88-52.57-4.52Q-52.57-4.16-52.80-3.93Q-53.03-3.71-53.39-3.71Q-53.75-3.71-53.97-3.93ZM-51.75 4.18L-55.00 4.18L-55.00 3.79Q-54.28 3.74-54.14 3.63Q-54.00 3.53-54.00 3.02L-54.00 3.02L-54.00-1.17Q-54.00-1.51-54.08-1.62Q-54.16-1.73-54.42-1.77L-54.42-1.77L-54.93-1.83L-54.93-2.17L-52.84-2.50L-52.75-2.42L-52.75 3.02Q-52.75 3.53-52.61 3.63Q-52.47 3.74-51.75 3.79L-51.75 3.79L-51.75 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4043",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4044)",
    opacity: 1,
    d: "M-50.90 0.97L-50.90 0.97Q-50.90-0.60-50.12-1.55Q-49.34-2.50-47.84-2.50L-47.84-2.50Q-47.15-2.50-46.63-2.29Q-46.11-2.09-45.84-1.79Q-45.57-1.50-45.40-1.10Q-45.23-0.70-45.19-0.41Q-45.15-0.12-45.15 0.17L-45.15 0.17Q-45.15 0.68-45.69 0.68L-45.69 0.68L-49.52 0.68Q-49.57 3.66-47.56 3.66L-47.56 3.66Q-46.84 3.66-46.40 3.29Q-45.95 2.91-45.63 2.25L-45.63 2.25L-45.23 2.46Q-45.87 4.34-47.83 4.34L-47.83 4.34Q-50.90 4.34-50.90 0.97ZM-49.50 0.17L-49.50 0.17L-46.99 0.17Q-46.72 0.17-46.63 0.07Q-46.54-0.04-46.54-0.25L-46.54-0.25Q-46.54-0.44-46.56-0.64Q-46.58-0.84-46.66-1.10Q-46.75-1.37-46.90-1.56Q-47.04-1.75-47.31-1.89Q-47.57-2.03-47.92-2.03L-47.92-2.03Q-48.40-2.03-48.74-1.77Q-49.09-1.51-49.24-1.12Q-49.38-0.73-49.44-0.41Q-49.50-0.09-49.50 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4044",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4045)",
    opacity: 1,
    d: "M-41.04 4.18L-44.29 4.18L-44.29 3.79Q-43.57 3.74-43.43 3.63Q-43.29 3.53-43.29 3.02L-43.29 3.02L-43.29-1.17Q-43.29-1.51-43.37-1.62Q-43.45-1.73-43.72-1.77L-43.72-1.77L-44.22-1.83L-44.22-2.17L-42.24-2.50L-42.05-1.49Q-42.00-1.53-41.72-1.71Q-41.44-1.89-41.38-1.93Q-41.31-1.97-41.08-2.10Q-40.84-2.23-40.73-2.27Q-40.62-2.31-40.41-2.39Q-40.21-2.46-40.02-2.48Q-39.83-2.50-39.63-2.50L-39.63-2.50Q-38.72-2.50-38.20-1.94Q-37.68-1.38-37.68-0.38L-37.68-0.38L-37.68 3.02Q-37.68 3.53-37.54 3.63Q-37.40 3.74-36.68 3.79L-36.68 3.79L-36.68 4.18L-39.93 4.18L-39.93 3.79Q-39.21 3.74-39.07 3.63Q-38.93 3.53-38.93 3.02L-38.93 3.02L-38.93-0.12Q-38.93-1.78-40.33-1.78L-40.33-1.78Q-40.83-1.78-41.26-1.51Q-41.68-1.24-41.91-0.82L-41.91-0.82Q-42.04-0.56-42.04-0.09L-42.04-0.09L-42.04 3.02Q-42.04 3.53-41.90 3.63Q-41.76 3.74-41.04 3.79L-41.04 3.79L-41.04 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4045",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4046)",
    opacity: 1,
    d: "M-35.11-1.81L-36.07-1.81L-36.07-2.34L-35.06-2.34L-34.25-4.01L-33.86-4.01L-33.86-2.34L-32.15-2.34L-32.15-1.81L-33.86-1.81L-33.86 2.32Q-33.86 3.65-32.98 3.65L-32.98 3.65Q-32.45 3.65-32.04 3.47L-32.04 3.47L-31.93 3.75Q-32.88 4.34-33.64 4.34L-33.64 4.34Q-33.86 4.34-34.07 4.28Q-34.29 4.23-34.54 4.09Q-34.79 3.95-34.95 3.63Q-35.11 3.30-35.11 2.82L-35.11 2.82L-35.11-1.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4046",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4047)",
    opacity: 1,
    d: "M-30.98 3.50L-30.98 3.50Q-30.98 3.13-30.74 2.88Q-30.51 2.64-30.14 2.64L-30.14 2.64Q-29.75 2.64-29.53 2.88Q-29.30 3.13-29.30 3.50L-29.30 3.50Q-29.31 3.87-29.53 4.10Q-29.75 4.34-30.14 4.34L-30.14 4.34Q-30.51 4.34-30.74 4.10Q-30.98 3.86-30.98 3.50Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4047",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4048)",
    opacity: 1,
    d: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4048",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4049)",
    opacity: 1,
    d: "M-21.00 4.18L-24.92 4.18L-24.92 3.79Q-24.05 3.74-23.89 3.62Q-23.73 3.50-23.73 2.94L-23.73 2.94L-23.73-3.79Q-23.73-4.35-23.89-4.47Q-24.05-4.59-24.92-4.64L-24.92-4.64L-24.92-5.03L-21.21-5.03Q-19.64-5.03-18.79-4.49L-18.79-4.49Q-17.76-3.84-17.76-2.42L-17.76-2.42Q-17.76-1.29-18.39-0.65Q-19.03-0.01-19.95 0.23L-19.95 0.23Q-20.65 0.40-21.65 0.40L-21.65 0.40L-22.41 0.40L-22.41 2.94Q-22.41 3.50-22.22 3.62Q-22.02 3.74-21.00 3.79L-21.00 3.79L-21.00 4.18ZM-22.41-4.07L-22.41-0.58Q-22.41-0.22-22.23-0.14Q-22.05-0.06-21.43-0.06L-21.43-0.06Q-20.47-0.06-19.83-0.62Q-19.19-1.17-19.19-2.33L-19.19-2.33Q-19.19-3.40-19.78-3.98Q-20.36-4.56-21.40-4.56L-21.40-4.56Q-22.02-4.56-22.22-4.46Q-22.41-4.36-22.41-4.07L-22.41-4.07Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4049",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4050)",
    opacity: 1,
    d: "M-17.16 0.97L-17.16 0.97Q-17.16-0.60-16.38-1.55Q-15.60-2.50-14.10-2.50L-14.10-2.50Q-13.41-2.50-12.89-2.29Q-12.37-2.09-12.10-1.79Q-11.82-1.50-11.66-1.10Q-11.49-0.70-11.45-0.41Q-11.41-0.12-11.41 0.17L-11.41 0.17Q-11.41 0.68-11.94 0.68L-11.94 0.68L-15.77 0.68Q-15.83 3.66-13.82 3.66L-13.82 3.66Q-13.10 3.66-12.65 3.29Q-12.21 2.91-11.89 2.25L-11.89 2.25L-11.49 2.46Q-12.13 4.34-14.08 4.34L-14.08 4.34Q-17.16 4.34-17.16 0.97ZM-15.76 0.17L-15.76 0.17L-13.25 0.17Q-12.98 0.17-12.89 0.07Q-12.79-0.04-12.79-0.25L-12.79-0.25Q-12.79-0.44-12.81-0.64Q-12.83-0.84-12.92-1.10Q-13.01-1.37-13.15-1.56Q-13.30-1.75-13.57-1.89Q-13.83-2.03-14.18-2.03L-14.18-2.03Q-14.66-2.03-15.00-1.77Q-15.35-1.51-15.49-1.12Q-15.64-0.73-15.70-0.41Q-15.76-0.09-15.76 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4050",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4051)",
    opacity: 1,
    d: "M-7.04 4.18L-10.55 4.18L-10.55 3.79Q-9.84 3.74-9.70 3.63Q-9.55 3.53-9.55 3.02L-9.55 3.02L-9.55-1.17Q-9.55-1.51-9.63-1.62Q-9.71-1.73-9.97-1.77L-9.97-1.77L-10.48-1.83L-10.48-2.17L-8.46-2.50L-8.30-1.43Q-7.59-2.05-7.24-2.27Q-6.89-2.50-6.54-2.50L-6.54-2.50Q-6.18-2.50-6.01-2.30Q-5.84-2.10-5.84-1.85L-5.84-1.85Q-5.84-1.54-6.02-1.32Q-6.21-1.10-6.45-1.10L-6.45-1.10Q-6.60-1.10-6.72-1.17L-6.72-1.17Q-7.25-1.46-7.54-1.46L-7.54-1.46Q-7.82-1.46-8.06-1.12Q-8.30-0.78-8.30-0.09L-8.30-0.09L-8.30 3.02Q-8.30 3.53-8.11 3.63Q-7.93 3.74-7.04 3.79L-7.04 3.79L-7.04 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4051",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4052)",
    opacity: 1,
    d: "M-5.04 3.70L-5.17 1.96L-4.79 1.96Q-4.34 3.87-2.85 3.87L-2.85 3.87Q-2.31 3.87-1.96 3.57Q-1.61 3.27-1.61 2.77L-1.61 2.77Q-1.61 2.45-1.74 2.20Q-1.86 1.96-2.11 1.80Q-2.35 1.64-2.55 1.55Q-2.75 1.46-3.05 1.37L-3.05 1.37Q-3.99 1.08-4.52 0.64Q-5.05 0.20-5.05-0.56L-5.05-0.56Q-5.05-1.49-4.40-1.99Q-3.74-2.50-2.63-2.50L-2.63-2.50Q-1.54-2.50-0.92-2.05L-0.92-2.05L-0.92-0.49L-1.30-0.49Q-1.38-1.16-1.76-1.59Q-2.13-2.03-2.79-2.03L-2.79-2.03Q-3.31-2.03-3.65-1.75Q-3.99-1.46-3.99-0.96L-3.99-0.96Q-3.99-0.61-3.72-0.34Q-3.44-0.08-3.21 0.02Q-2.97 0.11-2.57 0.24L-2.57 0.24Q-1.48 0.57-0.98 1.05Q-0.48 1.53-0.48 2.37L-0.48 2.37Q-0.48 3.23-1.14 3.79Q-1.81 4.34-2.97 4.34L-2.97 4.34Q-4.32 4.34-5.04 3.70L-5.04 3.70Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4052",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4053)",
    opacity: 1,
    d: "M1.45-3.93Q1.22-4.16 1.22-4.52Q1.22-4.88 1.45-5.11Q1.68-5.33 2.03-5.33Q2.39-5.33 2.62-5.11Q2.85-4.88 2.85-4.52Q2.85-4.16 2.62-3.93Q2.39-3.71 2.03-3.71Q1.68-3.71 1.45-3.93ZM3.67 4.18L0.43 4.18L0.43 3.79Q1.14 3.74 1.28 3.63Q1.42 3.53 1.42 3.02L1.42 3.02L1.42-1.17Q1.42-1.51 1.34-1.62Q1.26-1.73 1.00-1.77L1.00-1.77L0.49-1.83L0.49-2.17L2.58-2.50L2.67-2.42L2.67 3.02Q2.67 3.53 2.81 3.63Q2.95 3.74 3.67 3.79L3.67 3.79L3.67 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4053",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4054)",
    opacity: 1,
    d: "M4.63 3.70L4.50 1.96L4.88 1.96Q5.33 3.87 6.82 3.87L6.82 3.87Q7.35 3.87 7.71 3.57Q8.06 3.27 8.06 2.77L8.06 2.77Q8.06 2.45 7.93 2.20Q7.81 1.96 7.56 1.80Q7.32 1.64 7.12 1.55Q6.92 1.46 6.62 1.37L6.62 1.37Q5.68 1.08 5.15 0.64Q4.62 0.20 4.62-0.56L4.62-0.56Q4.62-1.49 5.27-1.99Q5.93-2.50 7.04-2.50L7.04-2.50Q8.13-2.50 8.75-2.05L8.75-2.05L8.75-0.49L8.37-0.49Q8.29-1.16 7.91-1.59Q7.54-2.03 6.88-2.03L6.88-2.03Q6.36-2.03 6.02-1.75Q5.68-1.46 5.68-0.96L5.68-0.96Q5.68-0.61 5.95-0.34Q6.22-0.08 6.46 0.02Q6.70 0.11 7.10 0.24L7.10 0.24Q8.19 0.57 8.69 1.05Q9.19 1.53 9.19 2.37L9.19 2.37Q9.19 3.23 8.53 3.79Q7.86 4.34 6.70 4.34L6.70 4.34Q5.35 4.34 4.63 3.70L4.63 3.70Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4054",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4055)",
    opacity: 1,
    d: "M11.04-1.81L10.08-1.81L10.08-2.34L11.09-2.34L11.90-4.01L12.29-4.01L12.29-2.34L14.00-2.34L14.00-1.81L12.29-1.81L12.29 2.32Q12.29 3.65 13.17 3.65L13.17 3.65Q13.70 3.65 14.11 3.47L14.11 3.47L14.22 3.75Q13.27 4.34 12.52 4.34L12.52 4.34Q12.29 4.34 12.08 4.28Q11.86 4.23 11.61 4.09Q11.36 3.95 11.20 3.63Q11.04 3.30 11.04 2.82L11.04 2.82L11.04-1.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4055",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4056)",
    opacity: 1,
    d: "M14.90 0.97L14.90 0.97Q14.90-0.60 15.67-1.55Q16.45-2.50 17.96-2.50L17.96-2.50Q18.65-2.50 19.17-2.29Q19.68-2.09 19.96-1.79Q20.23-1.50 20.40-1.10Q20.56-0.70 20.60-0.41Q20.64-0.12 20.64 0.17L20.64 0.17Q20.64 0.68 20.11 0.68L20.11 0.68L16.28 0.68Q16.23 3.66 18.23 3.66L18.23 3.66Q18.95 3.66 19.40 3.29Q19.84 2.91 20.16 2.25L20.16 2.25L20.56 2.46Q19.92 4.34 17.97 4.34L17.97 4.34Q14.90 4.34 14.90 0.97ZM16.29 0.17L16.29 0.17L18.81 0.17Q19.07 0.17 19.17 0.07Q19.26-0.04 19.26-0.25L19.26-0.25Q19.26-0.44 19.24-0.64Q19.22-0.84 19.13-1.10Q19.05-1.37 18.90-1.56Q18.75-1.75 18.49-1.89Q18.22-2.03 17.88-2.03L17.88-2.03Q17.40-2.03 17.05-1.77Q16.70-1.51 16.56-1.12Q16.41-0.73 16.35-0.41Q16.29-0.09 16.29 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4056",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4057)",
    opacity: 1,
    d: "M24.75 4.18L21.51 4.18L21.51 3.79Q22.22 3.74 22.36 3.63Q22.50 3.53 22.50 3.02L22.50 3.02L22.50-1.17Q22.50-1.51 22.42-1.62Q22.34-1.73 22.08-1.77L22.08-1.77L21.57-1.83L21.57-2.17L23.55-2.50L23.74-1.49Q23.79-1.53 24.07-1.71Q24.35-1.89 24.42-1.93Q24.49-1.97 24.72-2.10Q24.95-2.23 25.06-2.27Q25.18-2.31 25.38-2.39Q25.59-2.46 25.78-2.48Q25.96-2.50 26.16-2.50L26.16-2.50Q27.08-2.50 27.60-1.94Q28.12-1.38 28.12-0.38L28.12-0.38L28.12 3.02Q28.12 3.53 28.26 3.63Q28.40 3.74 29.11 3.79L29.11 3.79L29.11 4.18L25.87 4.18L25.87 3.79Q26.59 3.74 26.73 3.63Q26.87 3.53 26.87 3.02L26.87 3.02L26.87-0.12Q26.87-1.78 25.47-1.78L25.47-1.78Q24.96-1.78 24.54-1.51Q24.11-1.24 23.89-0.82L23.89-0.82Q23.75-0.56 23.75-0.09L23.75-0.09L23.75 3.02Q23.75 3.53 23.89 3.63Q24.03 3.74 24.75 3.79L24.75 3.79L24.75 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4057",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4058)",
    opacity: 1,
    d: "M30.68-1.81L29.73-1.81L29.73-2.34L30.74-2.34L31.55-4.01L31.93-4.01L31.93-2.34L33.65-2.34L33.65-1.81L31.93-1.81L31.93 2.32Q31.93 3.65 32.81 3.65L32.81 3.65Q33.34 3.65 33.76 3.47L33.76 3.47L33.86 3.75Q32.92 4.34 32.16 4.34L32.16 4.34Q31.93 4.34 31.72 4.28Q31.51 4.23 31.26 4.09Q31.00 3.95 30.84 3.63Q30.68 3.30 30.68 2.82L30.68 2.82L30.68-1.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4058",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4059)",
    opacity: 1,
    d: "M34.82 3.50L34.82 3.50Q34.82 3.13 35.05 2.88Q35.28 2.64 35.66 2.64L35.66 2.64Q36.04 2.64 36.27 2.88Q36.50 3.13 36.50 3.50L36.50 3.50Q36.48 3.87 36.26 4.10Q36.04 4.34 35.66 4.34L35.66 4.34Q35.28 4.34 35.05 4.10Q34.82 3.86 34.82 3.50Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4059",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4060)",
    opacity: 1,
    d: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4060",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4061)",
    opacity: 1,
    d: "M41.20 3.58L41.07 1.45L41.50 1.45Q41.75 2.60 42.37 3.25Q42.99 3.91 43.90 3.91L43.90 3.91Q44.79 3.91 45.31 3.42Q45.82 2.93 45.82 2.08L45.82 2.08Q45.82 1.53 45.45 1.07Q45.09 0.61 44.73 0.41Q44.37 0.21 43.97 0.06L43.97 0.06L43.73-0.04Q42.55-0.45 41.88-1.07Q41.22-1.69 41.22-2.66L41.22-2.66Q41.22-3.91 42.09-4.57Q42.97-5.23 44.28-5.23L44.28-5.23Q45.81-5.23 46.54-4.64L46.54-4.64L46.54-2.76L46.12-2.76Q45.81-4.76 44.13-4.76L44.13-4.76Q43.32-4.76 42.87-4.29Q42.43-3.83 42.43-3.07L42.43-3.07Q42.43-2.51 42.88-2.07Q43.33-1.63 44.06-1.37L44.06-1.37L44.49-1.21Q45.78-0.73 46.44-0.08Q47.11 0.57 47.11 1.68L47.11 1.68Q47.11 2.81 46.29 3.59Q45.47 4.38 43.82 4.38L43.82 4.38Q43.08 4.38 42.35 4.17Q41.62 3.97 41.20 3.58L41.20 3.58Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4061",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4062)",
    opacity: 1,
    d: "M48.09 0.97L48.09 0.97Q48.09-0.60 48.87-1.55Q49.65-2.50 51.15-2.50L51.15-2.50Q51.84-2.50 52.36-2.29Q52.88-2.09 53.15-1.79Q53.43-1.50 53.59-1.10Q53.76-0.70 53.80-0.41Q53.84-0.12 53.84 0.17L53.84 0.17Q53.84 0.68 53.31 0.68L53.31 0.68L49.48 0.68Q49.42 3.66 51.43 3.66L51.43 3.66Q52.15 3.66 52.59 3.29Q53.04 2.91 53.36 2.25L53.36 2.25L53.76 2.46Q53.12 4.34 51.17 4.34L51.17 4.34Q48.09 4.34 48.09 0.97ZM49.49 0.17L49.49 0.17L52.00 0.17Q52.27 0.17 52.36 0.07Q52.46-0.04 52.46-0.25L52.46-0.25Q52.46-0.44 52.44-0.64Q52.42-0.84 52.33-1.10Q52.24-1.37 52.10-1.56Q51.95-1.75 51.68-1.89Q51.42-2.03 51.07-2.03L51.07-2.03Q50.59-2.03 50.25-1.77Q49.90-1.51 49.76-1.12Q49.61-0.73 49.55-0.41Q49.49-0.09 49.49 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4062",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4063)",
    opacity: 1,
    d: "M54.93 0.99L54.93 0.99Q54.93 0.28 55.10-0.31Q55.27-0.90 55.63-1.41Q55.99-1.91 56.64-2.21Q57.28-2.50 58.16-2.50L58.16-2.50Q59.19-2.50 59.83-2.10Q60.48-1.70 60.48-1.21L60.48-1.21Q60.48-0.88 60.22-0.70Q59.96-0.53 59.69-0.53L59.69-0.53Q59.41-0.53 59.28-0.88L59.28-0.88Q58.85-2.03 58.01-2.03L58.01-2.03Q57.27-2.03 56.79-1.35Q56.31-0.66 56.31 0.75L56.31 0.75Q56.31 1.27 56.40 1.74Q56.49 2.21 56.69 2.66Q56.90 3.11 57.30 3.38Q57.71 3.65 58.27 3.65L58.27 3.65Q58.97 3.65 59.42 3.30Q59.86 2.95 60.18 2.24L60.18 2.24L60.57 2.42Q60.40 3.09 59.94 3.54Q59.49 3.99 59.01 4.16Q58.52 4.34 58.01 4.34L58.01 4.34Q56.51 4.34 55.72 3.49Q54.93 2.64 54.93 0.99Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4063",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4064)",
    opacity: 1,
    d: "M61.73-1.77L61.22-1.83L61.22-2.17L63.31-2.50L63.40-2.42L63.40 2.10Q63.40 2.85 63.77 3.23Q64.13 3.62 64.74 3.62L64.74 3.62Q65.26 3.62 65.71 3.35Q66.15 3.07 66.38 2.62L66.38 2.62Q66.49 2.41 66.49 1.82L66.49 1.82L66.49-1.17Q66.49-1.51 66.41-1.62Q66.33-1.73 66.06-1.77L66.06-1.77L65.56-1.83L65.56-2.17L67.64-2.50L67.74-2.42L67.74 3.02Q67.74 3.53 67.88 3.63Q68.03 3.74 68.73 3.79L68.73 3.79L68.73 4.18L66.61 4.18L66.47 3.38Q66.46 3.39 65.98 3.69Q65.50 3.98 65.02 4.16Q64.54 4.34 64.04 4.34L64.04 4.34Q63.20 4.34 62.68 3.87Q62.15 3.41 62.15 2.34L62.15 2.34L62.15-1.17Q62.15-1.51 62.07-1.62Q61.99-1.73 61.73-1.77L61.73-1.77Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4064",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4065)",
    opacity: 1,
    d: "M72.87 4.18L69.36 4.18L69.36 3.79Q70.06 3.74 70.21 3.63Q70.36 3.53 70.36 3.02L70.36 3.02L70.36-1.17Q70.36-1.51 70.28-1.62Q70.20-1.73 69.93-1.77L69.93-1.77L69.43-1.83L69.43-2.17L71.45-2.50L71.61-1.43Q72.31-2.05 72.66-2.27Q73.02-2.50 73.36-2.50L73.36-2.50Q73.72-2.50 73.89-2.30Q74.07-2.10 74.07-1.85L74.07-1.85Q74.07-1.54 73.88-1.32Q73.70-1.10 73.46-1.10L73.46-1.10Q73.31-1.10 73.19-1.17L73.19-1.17Q72.66-1.46 72.37-1.46L72.37-1.46Q72.09-1.46 71.85-1.12Q71.61-0.78 71.61-0.09L71.61-0.09L71.61 3.02Q71.61 3.53 71.79 3.63Q71.98 3.74 72.87 3.79L72.87 3.79L72.87 4.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4065",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4066)",
    opacity: 1,
    d: "M74.49 0.97L74.49 0.97Q74.49-0.60 75.27-1.55Q76.05-2.50 77.55-2.50L77.55-2.50Q78.24-2.50 78.76-2.29Q79.28-2.09 79.55-1.79Q79.83-1.50 79.99-1.10Q80.16-0.70 80.20-0.41Q80.24-0.12 80.24 0.17L80.24 0.17Q80.24 0.68 79.71 0.68L79.71 0.68L75.88 0.68Q75.82 3.66 77.83 3.66L77.83 3.66Q78.55 3.66 79.00 3.29Q79.44 2.91 79.76 2.25L79.76 2.25L80.16 2.46Q79.52 4.34 77.57 4.34L77.57 4.34Q74.49 4.34 74.49 0.97ZM75.89 0.17L75.89 0.17L78.40 0.17Q78.67 0.17 78.76 0.07Q78.86-0.04 78.86-0.25L78.86-0.25Q78.86-0.44 78.84-0.64Q78.82-0.84 78.73-1.10Q78.64-1.37 78.50-1.56Q78.35-1.75 78.08-1.89Q77.82-2.03 77.47-2.03L77.47-2.03Q76.99-2.03 76.65-1.77Q76.30-1.51 76.16-1.12Q76.01-0.73 75.95-0.41Q75.89-0.09 75.89 0.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4066",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CUSTOM_SVGID_4067)",
    opacity: 1,
    d: "M81.34 3.50L81.34 3.50Q81.34 3.13 81.58 2.88Q81.81 2.64 82.18 2.64L82.18 2.64Q82.57 2.64 82.79 2.88Q83.02 3.13 83.02 3.50L83.02 3.50Q83.01 3.87 82.79 4.10Q82.57 4.34 82.18 4.34L82.18 4.34Q81.81 4.34 81.58 4.10Q81.34 3.86 81.34 3.50Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CUSTOM_SVGID_4067",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -116.27925206661223 -7.514499999999999)",
    x1: 0,
    y1: 0,
    x2: 232.55850413322446,
    y2: 15.028999999999998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040",
      stopOpacity: "undefined"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9ed32",
      stopOpacity: "undefined"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3142483085793355 -2.2779182514631993 2.2779182514631993 1.3142483085793355 97 249.99999999999957)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.183752050000002 -16.457491400000006)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "0.11939814999999498,28.9712663 25.149316750000004,14.3820825 25.03021435,-14.5888858 -0.1193637500000051,-28.9712663 -25.149316750000004,-14.3820853 0.0002956499999982043,-0.000295200000000051 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.303741450000004 23.64883039999999)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "25.030471849999998,-21.779926299999996 25.029327350000003,-21.779926299999996 -0.0005912500000064824,-7.191043799999992 -25.14957425,-21.572830199999995 -25.030544250000005,7.3978462 0.1197357499999967,21.779926299999996 25.14957425,7.190746299999997 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.236035150000006 0.40693379999999735)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "25.08976435,-14.589032199999998 -0.059809849999997056,-28.971117999999997 -25.089764349999996,-14.381936099999997 -24.970031949999996,14.589030299999997 0.17954325000000182,28.971117999999997 0.05988575000000296,0.00044540000000381497 "
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 348.04699236666056 248.24500672975063)",
    style: {}
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M-117.96 18.57L-131.97 18.57L-131.97 16.85Q-129.37 16.67-128.37 16.14Q-127.36 15.61-127.12 13.90L-127.12 13.90Q-126.71 11.18-126.71 6.57L-126.71 6.57L-126.71-16.84Q-126.71-19.32-127.42-19.85Q-128.13-20.38-132.03-20.62L-132.03-20.62L-132.03-22.33L-120.68-22.33Q-109.22-6.02-97.63 10.29L-97.63 10.29L-97.51 10.41L-97.51-10.33Q-97.51-14.94-97.93-17.66L-97.93-17.66Q-98.17-19.38-99.26-19.88Q-100.35-20.38-103.54-20.62L-103.54-20.62L-103.54-22.33L-89.54-22.33L-89.54-20.62Q-92.14-20.44-93.14-19.91Q-94.15-19.38-94.38-17.66L-94.38-17.66Q-94.80-14.94-94.80-10.33L-94.80-10.33L-94.80 18.57L-98.70 18.57Q-108.21 4.97-123.87-17.01L-123.87-17.01L-123.99-17.01L-123.99 6.57Q-123.99 11.18-123.58 13.90L-123.58 13.90Q-123.34 15.61-122.25 16.11Q-121.15 16.62-117.96 16.85L-117.96 16.85L-117.96 18.57Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M-86.82 4.32L-86.82 4.32Q-86.82-2.65-83.36-6.88Q-79.90-11.10-73.22-11.10L-73.22-11.10Q-70.15-11.10-67.85-10.19Q-65.54-9.27-64.33-7.97Q-63.12-6.67-62.38-4.90Q-61.64-3.12-61.46-1.82Q-61.29-0.52-61.29 0.78L-61.29 0.78Q-61.29 3.02-63.65 3.02L-63.65 3.02L-80.67 3.02Q-80.91 16.26-71.98 16.26L-71.98 16.26Q-68.79 16.26-66.81 14.61Q-64.83 12.95-63.41 10.00L-63.41 10.00L-61.64 10.94Q-64.48 19.27-73.17 19.27L-73.17 19.27Q-86.82 19.27-86.82 4.32ZM-80.61 0.78L-80.61 0.78L-69.44 0.78Q-68.26 0.78-67.85 0.30Q-67.43-0.17-67.43-1.11L-67.43-1.11Q-67.43-1.94-67.52-2.83Q-67.61-3.72-67.99-4.90Q-68.38-6.08-69.03-6.94Q-69.68-7.79-70.86-8.41Q-72.04-9.03-73.58-9.03L-73.58-9.03Q-75.71-9.03-77.24-7.88Q-78.78-6.73-79.43-4.99Q-80.08-3.24-80.35-1.82Q-80.61-0.41-80.61 0.78Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M-55.55-7.85L-57.80-8.15L-57.80-9.63L-48.52-11.10L-48.11-10.75L-48.11 9.35Q-48.11 12.66-46.48 14.37Q-44.86 16.08-42.14 16.08L-42.14 16.08Q-39.83 16.08-37.85 14.87Q-35.87 13.66-34.87 11.65L-34.87 11.65Q-34.40 10.71-34.40 8.10L-34.40 8.10L-34.40-5.19Q-34.40-6.73-34.75-7.20Q-35.11-7.67-36.29-7.85L-36.29-7.85L-38.53-8.15L-38.53-9.63L-29.25-11.10L-28.84-10.75L-28.84 13.42Q-28.84 15.67-28.19 16.14Q-27.54 16.62-24.41 16.85L-24.41 16.85L-24.41 18.57L-33.86 18.57L-34.46 15.02Q-34.51 15.08-36.64 16.38Q-38.77 17.68-40.90 18.48Q-43.02 19.27-45.27 19.27L-45.27 19.27Q-48.99 19.27-51.33 17.21Q-53.66 15.14-53.66 10.41L-53.66 10.41L-53.66-5.19Q-53.66-6.73-54.02-7.20Q-54.37-7.67-55.55-7.85L-55.55-7.85Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M-6.03 18.57L-21.63 18.57L-21.63 16.85Q-18.50 16.62-17.85 16.14Q-17.20 15.67-17.20 13.42L-17.20 13.42L-17.20-5.19Q-17.20-6.73-17.55-7.20Q-17.91-7.67-19.09-7.85L-19.09-7.85L-21.34-8.15L-21.34-9.63L-12.35-11.10L-11.64-6.37Q-8.51-9.09-6.94-10.10Q-5.38-11.10-3.84-11.10L-3.84-11.10Q-2.25-11.10-1.48-10.22Q-0.71-9.33-0.71-8.21L-0.71-8.21Q-0.71-6.85-1.54-5.87Q-2.36-4.90-3.43-4.90L-3.43-4.90Q-4.08-4.90-4.61-5.19L-4.61-5.19Q-6.97-6.49-8.27-6.49L-8.27-6.49Q-9.52-6.49-10.58-4.99Q-11.64-3.48-11.64-0.41L-11.64-0.41L-11.64 13.42Q-11.64 15.67-10.82 16.14Q-9.99 16.62-6.03 16.85L-6.03 16.85L-6.03 18.57Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M1.77 10.88L1.77 10.88Q1.77 5.50 7.27 3.85L7.27 3.85Q8.16 3.55 10.08 2.99Q12.00 2.43 13.09 2.08Q14.18 1.72 15.60 1.22Q17.02 0.72 17.88 0.24Q18.73-0.23 19.15-0.64L19.15-0.64L19.15-3.12Q19.15-6.32 17.67-7.67Q16.19-9.03 14.12-9.03L14.12-9.03Q9.75-9.03 8.04-3.24L8.04-3.24Q7.56-1.59 6.15-1.59L6.15-1.59Q5.08-1.59 3.96-2.33Q2.84-3.06 2.84-4.37L2.84-4.37Q2.84-6.91 6.38-9.00Q9.93-11.10 14.78-11.10L14.78-11.10Q17.97-11.10 20.03-10.39Q22.10-9.68 22.99-8.41Q23.88-7.14 24.17-5.99Q24.47-4.84 24.47-3.24L24.47-3.24L24.47 11.06Q24.47 15.67 26.54 16.14L26.54 16.14Q27.78 16.50 29.55 16.08L29.55 16.08L29.90 17.50Q26.36 19.27 22.93 19.27L22.93 19.27Q21.45 19.27 20.63 18.39Q19.80 17.50 19.09 15.73L19.09 15.73Q13.71 19.27 10.28 19.27L10.28 19.27Q6.32 19.27 4.05 16.85Q1.77 14.43 1.77 10.88ZM7.74 10.06L7.74 10.06Q7.74 12.77 9.13 14.46Q10.52 16.14 13.18 16.14L13.18 16.14Q15.43 16.14 17.29 14.72Q19.15 13.31 19.15 10.11L19.15 10.11L19.15 1.78Q18.03 2.49 12.35 4.62L12.35 4.62Q9.87 5.56 8.81 6.78Q7.74 7.99 7.74 10.06Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M32.62-1.59L32.62-1.59Q32.62-11.10 38.00-17.13L38.00-17.13Q43.44-23.22 54.67-23.22L54.67-23.22Q62.23-23.22 67.20-20.91L67.20-20.91L67.20-11.69L65.42-11.69Q63.89-21.15 54.08-21.15L54.08-21.15Q50.12-21.15 47.16-19.52Q44.21-17.90 42.52-15.06Q40.84-12.23 40.04-8.92Q39.24-5.61 39.24-1.76L39.24-1.76Q39.24 0.66 39.60 3.02Q39.95 5.39 40.96 8.05Q41.96 10.71 43.53 12.71Q45.09 14.72 47.78 16.05Q50.47 17.38 53.96 17.38L53.96 17.38Q59.40 17.38 62.20 14.64Q65.01 11.89 66.37 6.75L66.37 6.75L68.14 6.75L67.31 16.62Q65.13 17.80 61.43 18.62Q57.74 19.45 54.31 19.45L54.31 19.45Q43.26 19.45 38.24 14.43L38.24 14.43Q32.62 8.81 32.62-1.59Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M68.50-8.68L68.50-8.68L68.50-10.39L82.03-10.39L82.03-8.68L79.49-8.44Q78.54-8.38 78.40-7.88Q78.25-7.38 78.60-6.61L78.60-6.61Q81.85 2.67 85.87 13.19L85.87 13.19L85.99 13.19Q91.25-1.11 92.55-6.37L92.55-6.37Q93.02-8.21 91.72-8.38L91.72-8.38L88.65-8.68L88.65-10.39L100.00-10.39L100.00-8.68Q97.87-8.56 97.16-8.03Q96.45-7.50 95.62-5.67L95.62-5.67Q91.84 2.85 84.69 23.41L84.69 23.41Q83.63 26.54 82.47 28.55Q81.32 30.56 80.20 31.45Q79.08 32.34 78.22 32.60Q77.36 32.87 76.30 32.87L76.30 32.87Q74.53 32.87 73.34 31.89Q72.16 30.92 72.16 29.79L72.16 29.79Q72.16 28.55 73.02 27.52Q73.87 26.49 74.76 26.49L74.76 26.49Q75.59 26.49 76.53 27.31L76.53 27.31Q77.78 28.55 78.72 28.55L78.72 28.55Q80.20 28.55 81.32 26.07L81.32 26.07Q82.74 23.06 82.74 21.05L82.74 21.05Q82.74 19.51 82.27 18.15L82.27 18.15Q79.13 9.11 72.99-5.61L72.99-5.61Q72.22-7.56 71.42-8.06Q70.62-8.56 68.50-8.68Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 1,
    d: "M102.12-22.10L99.88-22.33L99.88-23.81L109.16-25.29L109.57-24.93L109.57-6.91Q109.75-7.02 111.37-8.06Q113.00-9.09 113.89-9.57Q114.77-10.04 116.46-10.57Q118.14-11.10 119.74-11.10L119.74-11.10Q122.75-11.10 125.00-9.89Q127.24-8.68 128.37-7.05Q129.49-5.43 130.17-3.21Q130.85-1.00 131.00 0.48Q131.14 1.96 131.14 3.44L131.14 3.44Q131.14 7.81 129.96 10.97Q128.78 14.13 126.68 15.91Q124.58 17.68 122.07 18.48Q119.56 19.27 116.43 19.27L116.43 19.27Q111.46 19.27 107.44 16.97L107.44 16.97L105.08 19.27L104.02 18.80L104.02-19.38Q104.02-21.03 103.66-21.50Q103.31-21.98 102.12-22.10L102.12-22.10ZM109.57-0.41L109.57 8.93Q109.57 11.41 109.99 12.66L109.99 12.66Q111.64 17.21 116.49 17.21L116.49 17.21Q125.00 17.21 125.00 3.79L125.00 3.79Q125.00 0.19 124.17-2.33Q123.34-4.84 122.04-5.96Q120.74-7.08 119.62-7.50Q118.50-7.91 117.37-7.91L117.37-7.91Q112.23-7.91 110.16-3.77L110.16-3.77Q109.57-2.59 109.57-0.41L109.57-0.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72b8a913ea5a7e9e0030165dd3570ca2.svg";
export { ForwardRef as ReactComponent };